import $ from 'jquery';
import Swal from 'sweetalert2';

export function initEksekusiApprovalSetting() {
    const pageId = $('#page-id').data('page');
    if (pageId !== 'eksekusi-approval-setting') return;

    // Add Setting Button
    $('#btnCreateSetting').on('click', function() {
        $('#formSetting')[0].reset();
        $('#setting_id').val('');
        $('#level').val('').trigger('change');
        $('#id_jabatan').val('').trigger('change');
        $('#modalSettingTitle').text('Tambah Setting Approval');
    });

    // Edit Setting Button
    $('.btn-edit-setting').on('click', function() {
        const id = $(this).data('id');
        const urlJson = $(this).data('url-json');
        $('#formSetting')[0].reset();
        $('#setting_id').val(id);
        $('#modalSettingTitle').text('Edit Setting Approval');
        
        $.get(urlJson, function(res) {
            if(res.status === 'success') {
                $('#level').val(res.data.level).trigger('change');
                
                if (res.data.id_jabatan) {
                    $('#id_jabatan').val(res.data.id_jabatan).trigger('change');
                }

                $('#modalSetting').modal('show');
            } else {
                Swal.fire('Error', res.message, 'error');
            }
        });
    });
}
